//setEscrowState 0

import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import DisplayedWeiData from '../DisplayedWeiData'

import { Web3StatusContext } from "../../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class SetEscrowState extends React.Component {
  static contextType = Web3StatusContext;

  state = { 
    inputState: 0,
    stackId: -1,
  };

  activeAccount = null;

  myChangeHandler = (event) => {
    let { value } = event.target;
    
    var inputState = value;
    this.setState({inputState: inputState});
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    var stackId;
    if(this.state.inputState == 0 || this.state.inputState == 1 ||
        this.state.inputState == 2) {
      stackId = GAMEFORESTSale.methods.setEscrowState.cacheSend(this.state.inputState);
      this.setState({ stackId: stackId });
    }
    else {
      console.log('state should be 0, 1 or 2');
    }
  }

  render() {

    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    return (
      <div>
          <form onSubmit={this.mySubmitHandler}>
            0 Active, 1 Refunding, 2 Closed
            <br/>
            <input
                type="number"
                value={this.state.inputState}
                onChange={this.myChangeHandler}
              />
              <br/>
            <input
            type='submit'
            value="Set State"
            />
          </form>
      </div>
    );
  }
};

export default SetEscrowState;
